import { render, staticRenderFns } from "./no_adoption_manuscript.vue?vue&type=template&id=455a3d88&scoped=true&"
import script from "./no_adoption_manuscript.vue?vue&type=script&lang=js&"
export * from "./no_adoption_manuscript.vue?vue&type=script&lang=js&"
import style0 from "./no_adoption_manuscript.vue?vue&type=style&index=0&id=455a3d88&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455a3d88",
  null
  
)

export default component.exports